export const clone = (obj) => JSON.parse(JSON.stringify(obj));
export const swapListItems = (list, oldIdx, newIdx) => {
    if (oldIdx === newIdx)
        return list;

    let movingItem = list[oldIdx];
    list.splice(oldIdx, 1);
    list.splice(newIdx, 0, movingItem);

    return list;
}
export const getRandomNum = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min));
}